import React, { FC, useEffect, useState } from 'react'
import { Alert, Button, Input, Modal, notification, Table, Typography } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import Icon from '../../components/Icon'
import { IScenario, IScenarioFileInitialValues, IScenarioInitialValues } from '../../types/scenario'
import { storageApi } from '../../api'
import SceneriosForm from '../New/ScenariosForm'

//TODO: REFACTOR FILE KEYS

const Scenarios: FC = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [isEditModalVisible, setIsEditModalVisible] = useState(false)
  const [isEditLoading, setIsEditLoading] = useState(false)
  const [selectedScenario, setSelectedScenario] = useState<IScenario>()
  const [editScenarioValues, setEditScenarioValues] = useState<IScenarioInitialValues>()
  const [scenarios, setScenarios] = useState<IScenario[]>([])

  async function fetchScenarios() {
    try {
      setIsLoading(true)
      const scenariosResponse = await storageApi.fetchScenarios()
      setScenarios(Array.isArray(scenariosResponse) ? scenariosResponse : [])
      setIsLoading(false)
    } catch {
      setScenarios([])
    }
  }

  async function deleteScenario(scenarioId: string) {
    setIsLoading(true)
    await storageApi.deleteScenario(scenarioId)
    fetchScenarios()
  }

  function editScenario(scenario: IScenario) {
    setSelectedScenario(scenario)
    setEditScenarioValues(mapApiResponseToInitialValues(scenario))
    setIsEditModalVisible(true)
  }

  //TODO: REFACTOR
  function onScenarioFieldChange(_: any, editedScenario: any) {
    // const { id, name } = selectedScenario || {}
    // if (!id || !name) return
    if (!selectedScenario) return
    // setSelectedScenario({ ...editedScenario, id, name })
    console.log(editedScenario)
    setEditScenarioValues(editedScenario)
  }

  function mapApiResponseToInitialValues(scenario?: IScenario): IScenarioInitialValues | undefined {
    if (!scenario) return

    const {
      dayAheadPrices,
      primaryFrequencyPrices,
      loadForecast,
      sellToGrid,
      purchaseFromFrom,
      storageSellPriceLimitDollars,
      timeSpan,
    } = scenario
    const files = { dayAheadPrices, primaryFrequencyPrices, loadForecast }

    const fileObjects: IScenarioFileInitialValues = Object.entries(files).reduce(
      (files, [fileKey, fileUrl], idx) => {
        if (fileUrl) {
          return { ...files, [fileKey]: [{ uid: idx, name: fileUrl, url: fileUrl }] }
        }
        return files
      },
      {
        dayAheadPrices: undefined,
        primaryFrequencyPrices: undefined,
        loadForecast: undefined,
      },
    )
    return { timeSpan, sellToGrid, purchaseFromFrom, storageSellPriceLimitDollars, ...fileObjects }
  }

  async function saveScenario() {
    try {
      if (selectedScenario && editScenarioValues) {
        setIsEditLoading(true)
        const scenarioId = selectedScenario.id
        await storageApi.editScenario(scenarioId, {
          id: scenarioId,
          name: selectedScenario.name,
          sellToGrid: editScenarioValues.sellToGrid || false,
          purchaseFromFrom: editScenarioValues.purchaseFromFrom || false,
          storageSellPriceLimitDollars: editScenarioValues.storageSellPriceLimitDollars,
          dayAheadPrices: editScenarioValues.dayAheadPrices?.[0]?.url || '',
          primaryFrequencyPrices: editScenarioValues.primaryFrequencyPrices?.[0]?.url || '',
          loadForecast: editScenarioValues.loadForecast?.[0]?.url || '',
          timeSpan: editScenarioValues.timeSpan,
        })
        notification.success({ message: 'Storage System has been edited successfully' })
        setIsEditModalVisible(false)
      }
    } finally {
      setIsEditLoading(false)
      fetchScenarios()
    }
  }

  useEffect(() => {
    fetchScenarios()
  }, [])
  console.log(scenarios)
  const scenariosTableColumns: ColumnsType<IScenario> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: 'Day Ahead',
      dataIndex: 'dayAheadPrices',
      key: 'dayAheadPrices',
      align: 'center',
      render: (fileLink) =>
        fileLink && <Typography.Link href={fileLink}>Day Ahead</Typography.Link>,
    },
    {
      title: 'Primary Freq.',
      dataIndex: 'primaryFrequencyPrices',
      key: 'primaryFrequencyPrices',
      align: 'center',
      render: (fileLink) =>
        fileLink && <Typography.Link href={fileLink}> Primary Freq.</Typography.Link>,
    },
    {
      title: 'Load Forecasts',
      dataIndex: 'loadForecast',
      key: 'loadForecast',
      align: 'center',
      render: (fileLink) =>
        fileLink && <Typography.Link href={fileLink}>Load Forecasts</Typography.Link>,
    },
    {
      title: 'Created Date',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date: string) => new Date(date).toLocaleString(),
      sorter: (a, b) => new Date(a.createdAt!).getTime() - new Date(b.createdAt!).getTime(),
    },
    {
      title: 'Created By',
      dataIndex: 'createdBy',
      key: 'createdBy',
    },
    {
      title: '',
      dataIndex: 'actions',
      key: 'actions',
      align: 'center',
      render: (_, scenario) => (
        <div>
          <Button
            className='mr-8'
            icon={<Icon icon='pen-to-square' margin={false} />}
            onClick={() => editScenario(scenario)}
          />
          <Button
            danger
            icon={<Icon icon='trash-alt' margin={false} />}
            onClick={() => deleteScenario(scenario.id)}
          />
        </div>
      ),
    },
  ]

  return (
    <div>
      <Alert
        type='info'
        message={<Typography.Title level={4}>Scenarios</Typography.Title>}
        description='Scenarios include different load and price forecasts that can be associated with different storage systems and different plants for different simulations. Each forecast file related with a scenario can be edited.'
      />

      <Input.Search className='my-24' placeholder='Search' onChange={fetchScenarios} />
      <Table columns={scenariosTableColumns} dataSource={scenarios} loading={isLoading} bordered />

      <Modal
        title={selectedScenario?.name}
        visible={isEditModalVisible}
        confirmLoading={isEditLoading}
        width={1200}
        okText='Save'
        closable={false}
        destroyOnClose
        onCancel={() => setIsEditModalVisible(false)}
        onOk={saveScenario}
      >
        <SceneriosForm
          initialValues={mapApiResponseToInitialValues(selectedScenario)}
          onValuesChange={onScenarioFieldChange}
        />
      </Modal>
    </div>
  )
}

export default Scenarios
